
import React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { useTranslation } from 'react-i18next';

interface FreeSessionFilterProps {
  showFreeSession: boolean;
  onToggle: (checked: boolean) => void;
}

const FreeSessionFilter: React.FC<FreeSessionFilterProps> = ({
  showFreeSession,
  onToggle,
}) => {
  const { t } = useTranslation('practitioners');

  return (
    <div className="space-y-3">
      <Label className="text-sm font-medium text-gray-700">
        {t('specialSessions')}
      </Label>
      <div className="flex items-center space-x-3">
        <Checkbox
          id="free-session-filter"
          checked={showFreeSession}
          onCheckedChange={(checked) => onToggle(checked as boolean)}
        />
        <Label 
          htmlFor="free-session-filter"
          className="text-sm font-normal cursor-pointer"
        >
          {t('internFreeSession')}
        </Label>
      </div>
      <p className="text-xs text-gray-500">
        {t('showPractitionersOffering')}
      </p>
    </div>
  );
};

export default FreeSessionFilter;
